'use es6';

import { is, List, Iterable, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
function deepFilterFunctions(collection = List()) {
  return collection.filterNot(a => typeof a === 'function').filterNot(a => a === undefined).map(a => Iterable.isIterable(a) ? deepFilterFunctions(a) : a);
}

// Checks if reports are equal, ignoring displayParam functions
export const reportsEqual = (reportA, reportB) => {
  const filteredA = reportA.update('displayParams', deepFilterFunctions);
  const filteredB = reportB.update('displayParams', deepFilterFunctions);
  return is(filteredA, filteredB);
};
export function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length || !ImmutableSet(keysA).equals(ImmutableSet(keysB))) {
    return false;
  }

  // Test for A's keys different from B.
  const bHasOwnProperty = hasOwnProperty.bind(objB);
  return keysA.reduce((val, key) => {
    const valA = objA[key];
    const valB = objB[key];
    if (key === 'report' && !reportsEqual(valB || ImmutableMap(), valA || ImmutableMap())) {
      return false;
    }
    if (!bHasOwnProperty(key) || valA !== valB && !is(valA, valB)) {
      return false;
    }
    return val;
  }, true);
}

// performs a shallow compare for components that have reports in props or state
export function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}